import { render } from "./TranslationList.vue?vue&type=template&id=090a83ea&scoped=true"
import script from "./TranslationList.vue?vue&type=script&lang=js"
export * from "./TranslationList.vue?vue&type=script&lang=js"

import "./TranslationList.vue?vue&type=style&index=0&id=090a83ea&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-090a83ea"

export default script